// extracted by mini-css-extract-plugin
export default {"container":"success-view_container","fadeIn":"success-view_fadeIn"};